import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["type", "disabled"]
const _hoisted_2 = ["src"]

import SharedService from "@/services/SharedService";
import { ItemButtonGroup } from '@/models/share.model';
import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'esButton',
  props: {
    label: {},
    disabled: { type: Boolean },
    styles: {},
    isPrimary: { type: Boolean },
    isLinked: { type: Boolean },
    isDanger: { type: Boolean },
    widthClass: {},
    type: {},
    iconContentButton: {},
    iconStyles: {}
  },
  setup(__props: any) {

const props = __props;

const buttonType = computed(() => props.type ?? 'button');

const getTxtClass = () => {
  let mainClass = props.disabled ? 'color-disabled' : props.isPrimary ? 'es-button-txt-primary' :  props.isLinked ? 'es-button-linked-txt' : props.isDanger ? 'es-button-txt-danger': 'es-button-txt';

  mainClass = props.styles ? props.styles : mainClass;

  const width = props.widthClass ? props.widthClass : 'default-width';

  return [mainClass, width];
};

const getSvgClass = () => {
const mainClass = props.disabled ? 'img-disabled' : '';

const propsClass = props.iconStyles ? props.iconStyles : '';

return [mainClass, propsClass];
};


const getIcon = (icon: string, isFillIcon: boolean, subPath: string) => {
  return SharedService.getIcon(icon, isFillIcon, subPath);
};

const getButtonClass = () => {
  return props.disabled ? 'button-disabled' : props.isPrimary ? 'es-button es-button-color-primary' :  props.isLinked ?  'es-button-linked' : 'es-button';
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: buttonType.value,
    class: _normalizeClass(getButtonClass()),
    disabled: _ctx.disabled
  }, [
    (_ctx.iconContentButton)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: getIcon(_ctx.iconContentButton.icon, false, _ctx.iconContentButton.pathIcon),
          class: _normalizeClass(["mright-04 mleft-04", getSvgClass()])
        }, null, 10, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("span", {
      class: _normalizeClass([getTxtClass(), "mright-04 mleft-04"])
    }, _toDisplayString(_ctx.label), 3)
  ], 10, _hoisted_1))
}
}

})